const ErrorMessage = ({ message }) => {
    return message.hasOwnProperty("text") ? (
        <div
            className={
                "text-left text-base " +
                (message.type === "SUCCESS"
                    ? "text-green-500"
                    : message.type === "ERROR"
                    ? "text-red-500"
                    : message.type === "WARNING"
                    ? "text-amber-500"
                    : null)
            }
        >
            <p>{message.text}</p>
        </div>
    ) : null;
};

export default ErrorMessage;
